<kendo-toolbar class="k-rtl" [overflow]="true" style="padding-top: 2px;"> 
  <!--overflow sets the automatic overflow menu to hide buttons when needed on smaller screen sizes-->
  <!--right to left kendo class-->
  <kendo-toolbar-button
    [fillMode]="'solid'"
    [themeColor]="'primary'"
    (click)="runQueryClick()"
    id="runQueryButton"
    [text]="'Run Query'"
    *ngIf="enableToolbarButtons"
    [disabled]="disableRunQueryButton()"
    className="smallToolbarButton"
  ></kendo-toolbar-button>
  <kendo-toolbar-button
    (click)="saveQueryClick(saveQueryDialogRef)"
    [fillMode]="'solid'"
    [themeColor]="'base'"
    id="saveQueryButton"
    [text]="'Save Query'"
    *ngIf="enableToolbarButtons"
    className="smallToolbarButton"
  ></kendo-toolbar-button>
  <kendo-toolbar-button
    (click)="resetQueryClick()"
    [fillMode]="'solid'"
    [themeColor]="'base'"
    id="resetQueryButton"
    [text]="'Reset'"
    className="smallToolbarButton"
  ></kendo-toolbar-button>
</kendo-toolbar>

<ng-template #saveQueryDialogRef>
  <kendo-floatinglabel style="width: 100%;" text="Query Name">
    <input id="queryNameTextbox" #queryNameTextbox kendoTextBox />
  </kendo-floatinglabel>
</ng-template>
